import {
  ISupplierUserProfile,
  ISupplierCompanyProfile,
} from 'constants/interfaces';
/**
 * Class to handle the authenticated user services
 */
export default class AuthenticatedUserService {
  private static user?: ISupplierUserProfile;
  static setUser(user: ISupplierUserProfile) {
    this.user = user;
  }

  static getUserId(): any {
    return this.user?.userId;
  }
  static getUserFullName(): any {
    return `${this.user?.name} ${this.user?.surname}`;
  }
  static getCompany(): ISupplierCompanyProfile | undefined {
    return this.user?.company;
  }
  static getInvitationCode(): string {
    return this.user?.invitationCode ?? '';
  }
}
